import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ACL } from '../../../config/constants';
import { hideSpinner, showSpinner } from "../../../store/actions/loading";
import { Paginator } from '../../layout/Paginator/Paginator';
import { Search } from '../../layout/Table/Search';
import { TableComponent } from "./table/Table";
import { store } from '../../../store/store';
import { hideNotification } from '../../../store/actions/notification';
import { AutoRefreshTable } from "../../layout/Table/AutoRefreshTable";
import { RowsPerPage } from "../../layout/Table/RowsPerPage";
import {getCampaignsApi} from "../../../api/campaigns/campaigns";
import { ListToolbar } from '../../layout/Workspace';

let oneTimeCall = false;
function CampaignTableComponent(props) {
  const [ sortDirection, setSortDirection ] = useState( null );
  const [ sortField, setSortField ] = useState( null );
  const [ searchText, setSearchText ] = useState( null );
  const [ campaigns, setCampaigns ] = useState( null );
  const [ meta, setMeta ] = useState( null );
  const [ rowsPerPage, setRowsPerPage ] = useState( 10 );

  useEffect( () => {
    getCampaigns( 1 );

    return () => {
      store.dispatch(hideNotification());
    }
  }, [] ); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect( () => {
    getCampaigns(1, sortField, sortDirection, searchText);

    return () => {
      store.dispatch(hideNotification());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPage] );

  /**
   * Get campaigns
   * @param {number} [page]
   * @param {string} [sortField]
   * @param {string} [sortDirection]
   * @param {string} [searchText]
   * @param {boolean} [hideNotification]
   */
  const getCampaigns = (page, sortField, sortDirection, searchText, hideNotification = false) => {
    if (! ACL.CLIENT.ORDERS.LIST.hasAccess() || oneTimeCall === true) {
      return;
    }

    oneTimeCall = true;

    getCampaignsApi( {
      pagination: {
        page: page,
        sort_by: sortField,
        sort: sortDirection,
        q: searchText,
        per_page: rowsPerPage,
      },
      hideNotification: hideNotification
    } ).then(
      response => {
        if (! response || ! response.data) {
          return;
        }

        setCampaigns( response.data );
        setMeta( response.meta );
        props.hideSpinner();
      }
    ).finally(() => {
      oneTimeCall = false;
    });
  };

  /**
   * Apply sort by appliedSortField
   * @param {string} appliedSortField
   */
  function applySort(appliedSortField) {
    let newSortDirection = "";

    if (sortField) {
      if (sortField === appliedSortField) {
        newSortDirection = sortDirection === "asc" ? "desc" : "asc";
      } else {
        newSortDirection = "asc";
      }
    } else {
      newSortDirection = "asc";
    }

    setSortField( appliedSortField );
    setSortDirection( newSortDirection );

    getCampaigns(meta.current_page, appliedSortField, newSortDirection, searchText, true);

  }

  return (
    <div className="campaigns-list-layout">
      <ListToolbar
        className="campaigns-list-toolbar"
        search={ACL.CLIENT.CAMPAIGNS.SEARCH.hasAccess() ? (
          <Search
            id="campaign"
            search={searchText => {
              setSearchText( searchText );
              getCampaigns( 1, null, null, searchText, true);
            }}
          />
        ) : null}
        settings={(
          <AutoRefreshTable
            id="orders"
            getData={ getCampaigns }
            sortDirection={ sortDirection }
            sortField={ sortField }
            searchText={ searchText }
          />
        )}
      />
      <div className="campaigns-list-table">
        <TableComponent
          shouldRenderFields={ true }
          applySort={ sortField => applySort( sortField ) }
          campaigns={ campaigns }
          actionCallback={
            useState => {
              if (useState) {
                getCampaigns(meta.current_page, sortField, sortDirection, searchText);
              } else {
                getCampaigns();
              }
            }
          }
        />
      </div>
      <div className="campaigns-list-pagination">
        <Paginator
          meta={ meta }
          settings={(
            <RowsPerPage
              id="campaign"
              changeRowsPerPage={rowsPerPage => {
                setRowsPerPage(rowsPerPage);
              }}
            />
          )}
          changePage={ page => getCampaigns(page, sortField, sortDirection, searchText, true) }
        />
      </div>
    </div>
  )
}

const CampaignTable = connect(null, { showSpinner, hideSpinner })(CampaignTableComponent);

export { CampaignTable, CampaignTableComponent };
